import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import ResumeBox from '@/common/components/ResumeBox'
import { DisableProductNfceMappingModal } from '@/features/productNfceMappings/components/DisableProductNfceMappingModal'
import { EnableProductNfceMappingModal } from '@/features/productNfceMappings/components/EnableProductNfceMappingModal'
import { useProductNfceMapping } from '@/features/productNfceMappings/hooks/useProductNfceMapping'
import { ChevronsRight } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const {
    data: productNfceMapping,
    isPending: isPendingProductNfceMapping,
    error: productNfceMappingError = {} as any,
    refetch: refetchProductNfceMapping,
  } = useProductNfceMapping(id || '')

  const disableUpdateButton = isPendingProductNfceMapping || productNfceMappingError?.status === 403
  const isEnabled = productNfceMapping?.status === 'active'

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/product-nfce-mappings" searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">Mapeamento de Produtos NFCe</p>

          <ChevronsRight color="#ffffffb3" />

          <h2>{productNfceMapping?.name}</h2>
        </div>

        <div className="flex gap-4">
          {isEnabled ? (
            <DisableProductNfceMappingModal productNfceMappingId={id || ''} disabled={isPendingProductNfceMapping} />
          ) : (
            <EnableProductNfceMappingModal productNfceMappingId={id || ''} disabled={isPendingProductNfceMapping} />
          )}

          <Link
            to={disableUpdateButton ? '' : `/product-nfce-mappings/${id}/edit`}
            className={disableUpdateButton ? 'cursor-default' : ''}
          >
            <Button
              operationKlassToCheckPermission="Admin::ProductNfceMappings::Update"
              data-testid="update_product_nfce_mapping_button"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        </div>
      </div>

      {isPendingProductNfceMapping ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={productNfceMappingError?.status}
          refetchFunction={refetchProductNfceMapping}
        >
          <Box className="flex max-h-[calc(100vh-128px)] flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)] overflow-y-auto">
            <p className="text-lg font-bold">Detalhes do mapeamento</p>

            <div className="flex gap-2">
              <ResumeBox label="Nome" value={productNfceMapping?.name ?? '--'} boxClassName="grow" />

              <ResumeBox
                label="Produto"
                value={productNfceMapping?.product?.display_name ?? '--'}
                boxClassName="grow"
              />
            </div>
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
